<template>
	<div id="receipt_wrapper">
		<form @submit.prevent="handleSubmit">
			<h1>{{ $t("blank-name-receipt-form.receipt_form_title_receipt_display_web_service") }}</h1>
			<div id="form-header-row" />
			<label for="name_on_receipt">
				<h1>{{ $t("blank-name-receipt-form.receipt_form_label_name_on_receipt") }}</h1>
				<div><input type="text" id="name_on_receipt" v-model="name" :placeholder="$t('blank-name-receipt-form.receipt_form_placeholder_name_on_receipt')" required pattern=".*\S+.*"></div>
			</label>
			<div id="form-navigation">
				<!-- <button id="back-button" @click.prevent="confirmGoBack">{{ $t('blank-name-receipt-form.button_back') }}</button> -->
				<input type="submit" :value="$t('blank-name-receipt-form.button_show_receipt')" id="show-receipt-button">
			</div>
		</form>
		<pdf-viewer v-if="receipt.src" :src="receipt.src" />
	</div>
</template>

<style lang="css" scoped>
#receipt_wrapper {
	padding-top: 100px;
}

h1 {
	font-family: Helvetica, sans-serif;
	font-weight: bold;
	color: #646464;
	font-size: 36px;
}

@media only screen and (max-width: 600px) {
	h1 {
		font-size: 24px;
	}
}

#form-header-row {
	width: 100%;
	height: 1px;
	background: #1e6687;
}

form {
	display: grid;
	grid-template-columns: auto;
	justify-items: center;
	margin-left: 10%;
	margin-right: 10%;
	max-width: 1000px;
}

form > label {
	display: grid;
	width: 100%;
	padding: 20px;
	grid-template-columns: 30% auto;
}

@media only screen and (max-width: 600px) {
	form {
		font-size: 14px;
	}

	form > label {
		grid-template-columns: auto;
	}
}

form > label > div > input {
	width: 100%;
	padding: 10px;
}

#form-navigation {
	display: grid;
	grid-template-columns: 200px; /* Set this to "100px 200px" if you plan to enable the back button. */
	column-gap: 10px;
	height: 36px;
}

#back-button {
	font-weight: bold;
	background: #5f5f5f;
	color: white;
	width: 100%;
}

#show-receipt-button {
	font-weight: bold;
	background: #d44217;
	color: white;
	width: 100%;
}

</style>

<script>
import PdfViewer from "./PdfViewer";
export default {
	components: { PdfViewer },
	name: 'Receipts',
	data() {
		return {
			name: '',
			receipt: {
                src: "",
            },
		};
	},
	async mounted() {
		this.facility = await this.$lionheart
		.post("/facility/list", { slug_name: this.$route.params.slug_name })
		.then((r) => this.catcher(r.data, "data[0].id", (r) => r.data[0]))
		.catch((e) => this.catcher(e));
		if (this.facility.error.has_error) return this.$router.push("/404");// TODO: Uncomment before push.
	},
	methods: {
		async handleSubmit() {
			const data = {
                facility_id: this.$router.currentRoute.query.facility_id,
                facility_visitor_log_id: this.$router.currentRoute.query.log_id,
				custom_name: this.name,
            };

			const receipt = await this.$lionheart.get("/facility-key/f/checkout/public-receipt", { params: data });

			if (receipt.data && receipt.data.data) {
                this.receipt.src = receipt.data.data;
				// console.log(this.$bvModal)
                setTimeout(() => this.$bvModal.show("modal-pdf-viewer"), 300);
            }
		},
		// confirmGoBack() {
		// 	if (confirm("You about to exit this page. Are you sure you want to go back?")) {
		// 		this.$router.go(-1)
		// 	}
		// }
	},
};
</script>
